// Texto del "próximo inicio" del turno para el Líder (design horario-turno-dia
// §6, tasks.md "Regla final de texto — próximo inicio del Líder").
//
// Puro: ambos parámetros son strings fake-UTC "YYYY-MM-DDTHH:MM" (pared local
// del tenant) ya resueltos por el backend — NUNCA se usa Date.now ni el reloj
// del browser acá.
//
// Dos variantes cerradas por diseño, sin una tercera ("mañana", "medianoche"
// entre paréntesis):
//   - `inicioLocal` cae en el MISMO día calendario que `ahoraLocal`, o es
//     EXACTAMENTE 00:00 del día siguiente (la medianoche que cierra el día
//     actual) → "Su turno inicia hoy a las HH:MM".
//   - Cualquier otro inicio dentro de la ventana de 12h que el backend ya
//     acotó → "Su turno inicia a las HH:MM" (sin nombre de día).

function addOneDayISO(fechaISO: string): string {
  const [y, m, d] = fechaISO.split('-').map(Number);
  if (!y || !m || !d) return fechaISO;
  return new Date(Date.UTC(y, m - 1, d + 1)).toISOString().slice(0, 10);
}

/** Texto del estado "próximo inicio" del turno (card del Líder, sin cuenta regresiva). */
export function textoProximoInicio(inicioLocal: string, ahoraLocal: string): string {
  const fechaInicio = inicioLocal.slice(0, 10);
  const horaInicio = inicioLocal.slice(11, 16);
  const fechaAhora = ahoraLocal.slice(0, 10);

  const esMismoDia = fechaInicio === fechaAhora;
  const esMedianocheQueCierraHoy =
    horaInicio === '00:00' && fechaInicio === addOneDayISO(fechaAhora);

  if (esMismoDia || esMedianocheQueCierraHoy) {
    return `Su turno inicia hoy a las ${horaInicio}`;
  }
  return `Su turno inicia a las ${horaInicio}`;
}
